import { t } from '@lingui/core/macro';
import type { BookingRecordListForCustomer } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiCard, NoddiInfoBanner, NoddiLink } from 'noddi-ui-web';
import { BookingDetailsTabs, CustomDateFormats, customerRoutes, NoddiDateFormats, noddiFormatDate } from 'noddi-util';

type Props = {
  booking: BookingRecordListForCustomer;
};

export const ExistingBookingForSeasonCard = ({ booking }: Props) => {
  return (
    <NoddiCard className='gap-6 border-warning/30 bg-warning/5'>
      <NoddiInfoBanner
        variant='warning'
        title={t`Existing booking found`}
        texts={[
          {
            value: t`There is already an active booking for this car this season.`
          }
        ]}
      />
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-2'>
          <div className='flex items-center gap-2 text-sm'>
            <NoddiIcon name='Calendar' size='small' />
            <span>{noddiFormatDate(booking.date, CustomDateFormats.FULL_WEEKDAY_MONTH_AND_YEAR)}</span>
          </div>
          <div className='flex items-center gap-2 text-sm'>
            <NoddiIcon name='Clock' size='small' />
            <span>
              {noddiFormatDate(booking.deliveryWindowStartsAt, NoddiDateFormats.TIME)}
              {' - '}
              {noddiFormatDate(booking.deliveryWindowEndsAt, NoddiDateFormats.TIME)}
            </span>
          </div>
          <div className='flex items-center gap-2 text-sm'>
            <NoddiIcon name='MapPin' size='small' />
            <span>
              {booking.address.streetName} {booking.address.streetNumber}
              {booking.address.city ? `, ${booking.address.city}` : ''}
            </span>
          </div>
        </div>
        <NoddiLink
          to={customerRoutes.bookingInfo.getPath({
            slug: booking.slug,
            tab: BookingDetailsTabs.ORDER_DETAILS
          })}
          variant='outline'
          size='small'
          startIcon='Edit'
        >
          {t`Edit booking`}
        </NoddiLink>
      </div>
    </NoddiCard>
  );
};
